import React from 'react';
import { withRouter } from 'react-router';
import { IonGrid, IonRow, IonCol, IonIcon } from '@ionic/react';
import { helpCircleOutline } from 'ionicons/icons';
import { connect } from 'react-redux';
import { withTranslation } from '../../lib/translate';
import { validateProfileData } from '../../lib/utils';
import { NormalText, SmallText, StrongText } from '../common';
import { setModal } from '../../store/actions';
import { getConfig } from '../../appConfig';
import './index.css';

const check = require('../../assets/images/Deli_Check.svg');

const ValidateButton = ({ __, dispatch, profile, auth }) => {
  const isAuth = auth.loggedIn;
  const valid = validateProfileData(profile).isValid;
  if (!getConfig().appType.hasEmailValidationEnabled) {
    return null;
  }
  return (
    <>
      {isAuth && !valid ? (
        <>
          <div className="validate-button">
            <StrongText className="validate-status">{__('Not Verified')}</StrongText>
            <NormalText
              onClick={() => dispatch(setModal('isVerfiedModalOpen', true))}
              className="pointer underlined"
            >
              {__('Verify Account')}
            </NormalText>
          </div>
        </>
      ) : isAuth && valid ? (
        <div className="validate-button valid">
          <StrongText className="validate-status">{__('Verified')}</StrongText>
        </div>
      ) : null}
    </>
  );
};

const stateToProps = (store) => {
  const { isVerfiedModalOpen, profile, auth } = store.profile;
  return {
    isVerfiedModalOpen,
    profile,
    auth,
  };
};

export default connect(stateToProps)(withRouter(withTranslation(ValidateButton)));
